import { ApiService } from "src/app/services/api.service";
import { TranslateService } from "@ngx-translate/core";
import { AccountService } from "./../../services/account.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  Component,
  Inject,
  Input,
  OnInit,
  ViewEncapsulation
  , ChangeDetectorRef
} from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Order } from "src/app/models/order";
import { UrlConstants } from "src/app/models/urlConstants";
import { CompanyDetails } from "src/app/models/company-details";
import { CompanyList } from "src/app/models/company-list";
import { SignalRService } from "src/app/services/signalr.service";
import Swal from "sweetalert2";
import { DatePipe } from "@angular/common";
import { SharedService } from "src/app/services/shared.service";
import { Account , Profile} from "src/app/screens/user-profile/client-data";
import { MarketWatchDetailService, StockDetail } from "src/app/services/market-watch-detail.service";
import { CommissionResponse } from "src/app/models/commission-response";
import { OrderService } from "src/app/services/order.service";


@Component({
  selector: "app-update-order",
  templateUrl: "./update-order.component.html",
  styleUrls: ["./update-order.component.scss"],
})
export class UpdateOrderComponent implements OnInit {
  orderToUpdate: Order;
  today: Date = new Date();
  isMarket: boolean;
  isSubmitting = false;
  isLoading = false;
  popoverTitle = "Popover title";
  popoverMessage = this.translate.instant("order-update-confirm");
  confirmText = this.translate.instant("submit");
  cancelText = this.translate.instant("cancel");
  orderTotal: any;
  orderFees: number;
  totalCost: any;
  clientData: any;
  confirmClicked = false;
  cancelClicked = false;
  avgCommission: any;
  minCommission: any;
  minCommissionUSD: any;
  initialQty: any;
  initialPrice: any;
  initialOrderValue: any;
  initialFees: any;
  initalTotalCost: any;
  isFetchingUserData: boolean;
  inputCustodian: number;
  custodianList: any;
  myShareSymbols: any;
  companies: CompanyList[];
  myCompanies: CompanyList[];
  accList: any;
  maxLimit: number;
  updateOrderForm = new FormGroup({
    qty: new FormControl("", Validators.required),
    price: new FormControl("", Validators.required),
    validTill: new FormControl("", Validators.required),
    tiffDate: new FormControl(),
  });
  companyDetails: CompanyDetails;
  company: CompanyList;
  titleMessage: string | HTMLElement | JQuery<HTMLElement>;
  textConfirmMassage: string;
  allMarketNames: StockDetail[];
  selectedAccount: Account
  public tabIndex = 0;
  inputUser: Account;
  userProfile:Profile;
  isMarketPrice: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<UpdateOrderComponent>,
    private http: HttpClient,
    private accService: AccountService,
    public datepipe: DatePipe,
    public translate: TranslateService,
    private apiService: ApiService,
    private signalService: SignalRService,
    private sharedService: SharedService,
    private _marketDetail: MarketWatchDetailService,
    private orderService: OrderService,
    private cdr: ChangeDetectorRef
  ) {
    this.orderToUpdate = { ...this.data.order };
    this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];

    // if (this.data["currentUser"] != null)
    //   this.updateOrderForm.get("client").patchValue(this.data["currentUser"]);
    // else this.updateOrderForm.get("client").patchValue(this.accList[0].relationCode);

    if (this.data["selectedAccount"]) {
      this.selectedAccount = this.data["selectedAccount"];
    }

    if (this.data["symbol"]) {
      this.company.SYMBOL_CODE = this.data["symbol"];
      if (this.data["custodianCode"]) {
        this.inputCustodian = this.data["custodianCode"];
        this.f.custodian?.patchValue(this.inputCustodian);
      }


    }
    if (this.data["price"] != null && this.data["qty"] != null) {
      this.updateOrderForm.get("price")?.patchValue(this.data["price"]);
      this.updateOrderForm.get("qty")?.patchValue(this.data["qty"]);
      this.maxLimit = this.companyDetails.MaxLimit;

    }
    if (this.sharedService.allMarketCompanies) {
      this.companies = this.sharedService.allMarketCompanies;
      this.onSelectClient(this.selectedAccount);
    } else
      this.apiService.fetchAllMarketWatch().subscribe((res) => {
        this.companies = res as CompanyList[];
        this.onSelectClient(this.selectedAccount);
      });



    // });

    this.tabIndex = this.data["type"];

    this.signalService.marketChanges.subscribe((res: any) =>
      res.forEach((element) => {
        if (element.SYMBOL_CODE == this.company.SYMBOL_CODE) {
          this.updateStockDetail(element);
          this.company = element;
          return;
        }
      })
    );

    if (this._marketDetail.marketNames)
      this.allMarketNames = this._marketDetail.marketNames?.getValue();
    this._marketDetail.namesSubject.subscribe((res) => {
      this.allMarketNames = res as StockDetail[];
    });
  }

  ngOnInit(): void {
    this.getClientData();
    this.fetchCommissions();
    this.fetchCompany();
    this.fetchSymbolBO();
    this.fetchCommissions();
    //this.fetchCompany();
    this.isLoading = true;
    const interval = setInterval(() => {
      if (this.company && this.avgCommission) {
        clearInterval(interval);
        this.isLoading = false;
        this.initializeForm();
        this.initializeInitialValues();
      }
    }, 100);
  }

  initializeForm(): void {
    this.updateOrderForm.patchValue({
      qty: this.orderToUpdate?.OrgQty || '',
      price: this.orderToUpdate?.OrgPrice || '',
      validTill: this.orderToUpdate?.TiffFlag || '0',
      tiffDate: this.orderToUpdate?.TiffDate || null
    });
  }

  initializeInitialValues(): void {
    this.initialPrice = this.orderToUpdate?.OrgPrice;
    this.initialQty = this.orderToUpdate?.OrgQty;
    this.initialOrderValue = this.updateOrderForm.get("price")?.value * this.updateOrderForm.get("qty")?.value;
    this.initialFees = this.calculateFees(this.initialOrderValue);
    this.initalTotalCost = this.initialOrderValue + this.initialFees;

    this.orderTotal = this.initialOrderValue;
    this.orderFees = this.initialFees;
    this.totalCost = this.initalTotalCost;
    this.setupValueChanges();
  }

  setupValueChanges(): void {
    let previousPrice = this.updateOrderForm.get("price").value;
    let marketPriceValue = null;
    this.updateOrderForm.valueChanges.subscribe((val) => {
       const currentPrice = this.updateOrderForm.get("price").value;
      
      if (this.isMarketPrice && marketPriceValue === null) {
        marketPriceValue = currentPrice;
      }

      if (this.isMarketPrice && currentPrice !== previousPrice && currentPrice !== marketPriceValue && previousPrice!="") {
        this.isMarketPrice = false;
        marketPriceValue = null;
      }

      previousPrice = currentPrice;
      const newOrderTotal = this.updateOrderForm.get("price")?.value * this.updateOrderForm.get("qty")?.value;
      const newOrderFees = this.calculateFees(newOrderTotal);
      const newTotalCost = newOrderTotal + newOrderFees;

      this.orderTotal = newOrderTotal;
      this.orderFees = newOrderFees;
      
      if (this.orderToUpdate.FixVal !== "2") {
        this.totalCost = newOrderTotal + newOrderFees;
      } 
      else {
    this.totalCost = newOrderTotal - newOrderFees;
      }
    });
  }

  ngAfterViewInit(): void {

    this.initialPrice = this.orderToUpdate?.OrgPrice;
    this.initialQty = this.orderToUpdate?.OrgQty;
    this.initialOrderValue = this.updateOrderForm.get("price")?.value * this.updateOrderForm.get("qty")?.value;
    this.initialFees = this.calculateFees(this.initialOrderValue);
    this.initalTotalCost = this.initialOrderValue + this.initialFees;
    this.updateOrderForm.valueChanges.subscribe((val) => {
      const newOrderTotal = this.updateOrderForm.get("price")?.value * this.updateOrderForm.get("qty")?.value;
      const newOrderFees = this.calculateFees(newOrderTotal);
      const newTotalCost = newOrderTotal + newOrderFees;

      if (newTotalCost > this.initalTotalCost) {
        // Calculate only the difference from initial total cost
        this.orderTotal = newOrderTotal - this.initialOrderValue;
        this.orderFees = this.calculateFees(this.orderTotal);
        if (this.orderToUpdate.FixVal !== '2') {
          this.totalCost = this.orderTotal + this.orderFees;
        }
        else {
          this.totalCost = this.orderTotal - this.orderFees;
        }
      } else {
        // Reset to initial values if new total cost does not exceed initial total cost
        this.orderTotal = 0;
        this.orderFees = 0;
        this.totalCost = 0;
      }
    });
  }


  fetchCommissions() {
    this.http.get<CommissionResponse>(`${UrlConstants.backofficeUrl}/api/Settings/GetConfiguredCommissions`)
      .subscribe((res) => {
        this.avgCommission = res.AvgCommission;
        this.minCommission = res.MinCommission;
        this.minCommissionUSD = res.MinCommissionUSD;
      });


  }
  submitOrder(): void {
    this.isSubmitting = true;
    let exccedingLimits = this.isExceedingLimits();
    if (!exccedingLimits) {
     const requestBody: any = {
        OrderNumber: this.orderToUpdate.OrderNumber,
        Qty: this.updateOrderForm.get("qty")?.value,
        Price: this.isMarketPrice ? 0 : this.updateOrderForm.get("price")?.value,
        TiffFlag: this.updateOrderForm.get("validTill")?.value,
        TiffDate: this.updateOrderForm.get("tiffDate")?.value,
      };

      // Add isMarketPrice only if true
      if (this.isMarketPrice) {
        requestBody.isMarketPrice = true;
      }
      this.http
        .post(UrlConstants.backofficeUrl + "/api/Orders/UpdateOrder", requestBody)
        .subscribe((res) => {
          this.isSubmitting = false;
          if (res["Errors"]?.length > 0) {
            this.dialogRef.close(res["Errors"][0]);
          } else if (res["Errors"] == null) {
            this.dialogRef.close(true);
          }
        });
    }
    else {
      let title = this.translate.currentLang == "en"
        ? "this action not allowed"
        : "خطأ فى الاستخدام";
      Swal.fire({
        icon: 'error',
        title: title,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'swal-btn'
        }
      });
      this.isSubmitting = false;
    }
  }
  calculateFees(orderValue) {
    let feePercentage = this.avgCommission;

    if (orderValue == 0) {
      feePercentage == 0;
    }

    let totalFees = orderValue * feePercentage;

    if (this.company?.CURRENCY == 1) {
      // For EGP
      if (totalFees < this.minCommission) {
        totalFees = this.minCommission;
      }
    } else {
      // For USD or other currencies
      if (totalFees < this.minCommissionUSD) {
        totalFees = this.minCommissionUSD;
      }
    }

    return totalFees;
  }

  isExceedingLimits() {
    if (this.orderToUpdate.FixVal !== "2") {
      const purchasePowerLimit =
        this.company?.CURRENCY == 2
          ? this.clientData?.purchasePower?.USD
          : this.clientData?.purchasePower?.EGP;

      return (this.totalCost > purchasePowerLimit);
    }
  }


  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  updateStockDetail(stock: CompanyList) {
    if (stock?.SYMBOL_CODE && this.allMarketNames) {
      let companyDetail = this.allMarketNames.find(
        (x) => x["SYMBOL_CODE"] === stock.SYMBOL_CODE
      );
      if (companyDetail) {
        stock.arb_shortname = companyDetail["arb_shortname"];
        stock.eng_shortname = companyDetail["eng_shortname"];
        stock.Reuters = companyDetail["Reuters"];
      }
    }
  }
  priceDecimalInput(event: any) {
    let reg;
    switch (this.companyDetails.RoundDigits) {
      case 0:
        reg = /^[0-9]*$/;
        break;
      case 1:
        reg = /^[0-9]*(\.\d{0,1})?$/;
        break;
      case 2:
        reg = /^[0-9]*(\.\d{0,2})?$/;
        break;
      case 3:
        reg = /^[0-9]*(\.\d{0,3})?$/;
        break;
      case 4:
        reg = /^[0-9]*(\.\d{0,4})?$/;
        break;
      case 5:
        reg = /^[0-9]*(\.\d{0,5})?$/;
        break;
    }

    // const reg = /^-?\d*(\.\d{0,2})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);

    if (!reg.test(input)) {
      event.preventDefault();
    }
  }
  onSelectClient(relCode) {
    this.isFetchingUserData = true;

    //fetch Purchase Power
    this.http
      .get(
        `${UrlConstants.backofficeUrl}/api/Client/GetClientPurchasePower?relationCode=` +
        relCode
      )
      .subscribe((res) => {
        if (res) {
          this.isFetchingUserData = false;
          this.clientData = res;
          this.fetchMySymbols();
          this.fetchCompany();
        }
      });

    //fetch Client Custodian
    this.http
      .get(
        `${UrlConstants.backofficeUrl}/api/Client/GetClientCustodianList?relationCode=` +
        relCode
      )
      .subscribe((res) => {
        if (res) {
          this.custodianList = res;
          if (!this.inputCustodian)
            this.f.custodian?.patchValue(this.custodianList[0]?.CustodianCode); // set first custodian
          this.f.execRule?.patchValue(0); //set regular
          this.f.validTill?.patchValue(0); //set today
        }
      });
  }

  get f() {
    return this.updateOrderForm.controls;
  }
  fetchMySymbols() {
    this.apiService
      .fetchMySymbols(this.selectedAccount)
      .subscribe((res) => {
        this.myShareSymbols = res;
        if (this.myShareSymbols?.length > 0)
          this.myCompanies = this.companies.filter((company) => {
            return this.myShareSymbols.indexOf(company.SYMBOL_CODE) != -1;
          });
      });
  }
  fetchSymbolBO() {
    this.apiService
      .fetchSymbolBO(this.orderToUpdate.SymbolCode)
      .subscribe((res: CompanyDetails) => {
        this.companyDetails = res;
      });
  }

  fetchCompany() {
    this.http
      .get(
        `${UrlConstants.feedUrl}/api/Feed/GetMarketWatchForSymbol?SYMBOL_CODE=` +
        this.orderToUpdate.SymbolCode
      )
      .subscribe((res) => {
        this.company = res as CompanyList;
        this.fetchSymbolBO();
      });

    // this.apiService.fetch
  }

  setMarketOrder() {
     if (this.isMarketPrice) {
      this.isMarketPrice = false;
      this.updateOrderForm.get("price").enable();
      this.updateOrderForm.get("price").patchValue(this.orderToUpdate.OrgPrice);
    } else {
      this.isMarketPrice = true;
      this.cdr.markForCheck();
      if (this.orderToUpdate.FixVal == "2")
        this.updateOrderForm
          .get("price")
          .patchValue(this.companyDetails.MinLimit);
      else if (this.orderToUpdate.FixVal == "1")
        this.updateOrderForm
          .get("price")
          .patchValue(this.companyDetails.MaxLimit);
      this.updateOrderForm.get("price").disable();
    }
    this.cdr.detectChanges();
  }

  getColor(item) {
    switch (item) {
      case 1:
        return {
          background: "rgb(40, 167, 69)",
          color: "white",
        };
      case 2:
        return {
          background: "#ff4643",
          color: "white",
        };
    }
  }
  getClientData() {

    this.http
    .get(
      `${UrlConstants.backofficeUrl}/api/Client/GetClientPurchasePower?relationCode=` +
        this.orderToUpdate.RelationCode
    )
    .subscribe((res) => {
      if (res) {
        this.isFetchingUserData = false;
        this.clientData = res;
      }
    });
    this.http
    .get(
      `${UrlConstants.backofficeUrl}/api/Client/GetClientProfile?relationCode=${this.orderToUpdate.RelationCode}`
    ).subscribe((res) => {
      if (res) {
        this.userProfile= res as Profile;
      }
    });
  }
  
}

